export const autoCompleteStyleOverride = {
    MuiAutocomplete: {
        styleOverrides: {
            paper: ({ theme }) => ({
                boxShadow: theme.customShadows.z20,
            }),
        },
    },
};
